import { useMutation } from "react-query";
import httpClient from "../http";

export type ICoupon = {
  _id: string;
  code: string;
  value: string;
};

export function useVerifyCoupon() {
  return useMutation(async (promoCode: string) => {
    const url = `coupons/code/${promoCode}`;
    const response = await httpClient.get(url);
    return response.data;
  });
}
